var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm._f("twoDigits")(_vm.days)))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c9a5b51","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Countdown2.vue
// module id = 868
// module chunks = 4